import { PaginatedResponse, WithListParams } from '@/types/pagination'
import { Subscription, SubscriptionStatus } from '@/types/subscription'
import { vpApi } from './vpApi'

type SubscriptionsResponse = PaginatedResponse<Subscription[]>

type SubscriptionListParams = WithListParams<{
  status?: SubscriptionStatus
}>

const getSubscriptions = async (params?: SubscriptionListParams) => {
  const res = await vpApi.get<SubscriptionsResponse>('/v1/subscriptions/', {
    params
  })

  return res.data
}

export const subscriptionApi = {
  getSubscriptions
}
